module.exports = __webpack_public_path__ + "static/divider-504f7a80633e39c4b7a337573ad8c55a.jpg";